import { FieldValues } from 'react-hook-form';

export function isControlledInput<K extends FieldValues>(props: any): props is K {
  return !!props.control;
}
